import clsx from 'clsx';
import { useRouter } from 'next/router';

import panierSrc from '~/src/assets/illustrations/panier.png';
import Button from '~/src/common/components/Button';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import I18n from '~/src/common/services/I18n';
import { useNiceModal } from '~/src/common/services/ModalsManager';
import { useGroceryListStore, useGroceryTermsStore } from '~/src/screens/GroceryList/utils';

import styles from './GroceryListBanner.module.scss';

interface Props {
  className?: string;
}

const GroceryListBanner = ({ className }: Props) => {
  const isGroceryListEnabled = useFeatureFlag('grocery-list');
  const [groceryList] = useGroceryListStore();
  const [groceryTerms] = useGroceryTermsStore();
  const groceryListModal = useNiceModal('grocery-list-modal');
  const router = useRouter();

  const updating =
    (groceryList != null && groceryList.length > 0) ||
    (groceryTerms != null && groceryTerms.length > 0);

  const translationKey = updating ? 'in-progress' : 'new';

  const primaryActionKey = updating
    ? 'grocery-list-banner.in-progress.button.continue'
    : 'grocery-list-banner.new.button';

  const redirectToCurrentGroceryList = () => {
    void router.push('/liste-de-courses');
  };

  const openListModal = () => {
    void groceryListModal.show();
  };

  if (!isGroceryListEnabled) return null;

  return (
    <div className={clsx(styles.container, className)}>
      <img src={panierSrc} className={styles.image} />
      <div className={styles.content}>
        <h3>{I18n.t(`grocery-list-banner.${translationKey}.title`)}</h3>
        <p>{I18n.t(`grocery-list-banner.${translationKey}.description`)}</p>
      </div>
      <div className={styles.actions}>
        {updating ? (
          <Button
            variant="secondary"
            onClick={() => {
              openListModal();
            }}>
            {I18n.t('grocery-list-banner.in-progress.button.new')}
          </Button>
        ) : null}
        <Button
          variant="primary"
          onClick={() => {
            if (updating) {
              redirectToCurrentGroceryList();
            } else {
              openListModal();
            }
          }}>
          {I18n.t(primaryActionKey)}
        </Button>
      </div>
    </div>
  );
};

export default GroceryListBanner;
